import React from 'react';
import classnames from 'classnames';

import './IndustrySelector.scss';

class IndustryItem extends React.Component {
  render() {
    return (
      <div className={classnames({
        'IndustryItem': true,
        'IndustryItem--Active': this.props.isActive,
      })} onClick={this.props.onClick}>
        <div className='CheckBox'>
          <input readOnly checked={this.props.isActive} type='checkbox' id={'CheckBox_' + this.props.Industry.name} />
        </div>
        <p className='IndustryItem__Name'>{this.props.Industry.name}</p>
      </div>
    );
  }
}

IndustryItem.defaultProps = {
  isActive: false,
  onClick: () => { },
};

class CollapsableSection extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      visibleState: false
    };
    this.toggleState = this.toggleState.bind(this);
  }

  toggleState() {
    this.setState({
      visibleState: this.state.visibleState === false
    });
  }

  render() {
    return (
      <div className='CollapsableSection'>
        <div className='CollapsableSection__Header' onClick={this.toggleState}>
          <span>{(this.state.visibleState) ? ' - ' : ' + '}</span>
          <h1>{this.props.title}</h1>
        </div>
        <div style={(this.state.visibleState) ? {} : { display: 'none' }} className='CollapsableSection__Body'>
          {this.props.children}
        </div>
      </div>
    );
  }
}

CollapsableSection.propTypes = {
  title: React.PropTypes.string.isRequired,
  children: React.PropTypes.node,
};

const IndustryTag = (props) => (
  <div className='IndustryTag'>
    <p className='IndustryTag__Name'>{props.name}</p>
    <a className='IndustryTag__Cancel' onClick={props.onClick}>×</a>
  </div>
);

class IndustrySelector extends React.Component {
  constructor(props, context) {
    super(props, context);

    const IndustriesMap = props.Industries.reduce((a, b) => {
      return a.concat(b.industries);
    }, []).reduce((a, b) => {         // Final object is of shape {
      let Val = a;                    //   1: "Industry Name"
      Val[b.id] = b.name;             //   2: "Other Name"
      return Val;                     // }
    }, {});

    this.state = {
      currentVal: props.defaultValue ? props.defaultValue.reduce((sum, value) => {
      let intermitant = sum;
      intermitant[value] = true;
      return intermitant;
    }, {}) : {},
    IndustryKeys: IndustriesMap
    };

    this.toggleIndustry = this.toggleIndustry.bind(this);
    this.isActive = this.isActive.bind(this);
    this.propogateChange = this.propogateChange.bind(this);
  }

  toggleIndustry(id) {
    return () => {
      let newVal = this.state.currentVal;
      newVal[id] = newVal[id] !== true;

      this.propogateChange(newVal);

      this.setState({
        currentVal: newVal
      });
    };
  }

  isActive(id) {
    if (Object.prototype.hasOwnProperty.call(this.state.currentVal, id)) {
      return this.state.currentVal[id];
    }
    return false;
  }

  propogateChange(ReturnValue) {
    if (this.props.onChange && this.props.name) {
      this.props.onChange({
        type: 'change',
        target: {
          name: this.props.name,
          value: Object.keys(ReturnValue).reduce((sum, value) => {
            if (ReturnValue[value]) {
              return [
                ...sum,
                value
              ];
            }
            return sum;
          }, [])
        }
      });
    }
  }

  render() {
    return (
      <div className='IndustrySelector'>
        <div className='IndustrySelector__Selected'>
          {Object.keys(this.state.currentVal).map(index => {
            if (this.state.currentVal[index]) {
              return (
                <IndustryTag key={index} name={this.state.IndustryKeys[index]} onClick={this.toggleIndustry(index)} />
              );
            }
            return null;
          })}
        </div>
        {this.props.Industries.map(IndustryCategory => (
          <CollapsableSection key={IndustryCategory.id} title={IndustryCategory.name}>
            {IndustryCategory.industries.map(Industry => (
              <IndustryItem isActive={this.isActive(Industry.id)} onClick={this.toggleIndustry(Industry.id)} Industry={Industry} key={Industry.id} />
            ))}
          </CollapsableSection>
        ))}
      </div>
    );
  }
}

IndustrySelector.defaultProps = {
  defaultValue: []
};

export default IndustrySelector;



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Experience/components/IndustrySelector/index.js